import { action, observable } from 'mobx';
import { IGetAllProjectsObject } from 'cd-eft/models/Projects/projectsLibrary';
import { RouteComponentProps } from 'react-router-dom';
import { getSpatialRefByProject } from 'cd-eft/components/Projects/ProjectsLibrary/ProjectsLibraryVM';
import { UserInfoController } from 'cd-eft/services/eftPrjAdminApi';
import { emailToName, toTitleCase } from 'cd-eft/utils/stringUtilities';

// Need to change for new ProjectDataObject ?
export interface IProjectCardProps {
  project: IGetAllProjectsObject;
}

export class ProjectCardVM {
  props: IProjectCardProps;
  history: RouteComponentProps['history'];

  constructor(props: IProjectCardProps, history: RouteComponentProps['history']) {
    this.props = props;
    this.project = props.project;
    this.history = history;
    if (!(this.project.projectOwnerFirstName && this.project.projectOwnerLastName)) {
      this.newOwnerName = emailToName(this.project.lastChangedBy);
    } else {
      this.newOwnerName = `${toTitleCase(this.project.projectOwnerFirstName)} ${toTitleCase(this.project.projectOwnerLastName)}`
    }
  }

  @observable project = {} as IGetAllProjectsObject;
  @observable newOwnerName: string = '';

  @action.bound async handleClick() {
    this.history.push(`/projects/${this.project.projectUuid}`);
    await getSpatialRefByProject(this.project.projectUuid)
  }
}
